import React, { useState, useEffect } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import * as r from "../../js/constants/routes";
import { useSelector } from "react-redux";
import { useEditionRightsPerUserStatus } from "../../js/utils/customHooks";
import { userRole } from "../../js/constants/selectOptions";
import { FilterToolbar } from "../Widgets/Custom Inputs/Select";


const UsersStatsByEntityGrid = ({ label, baseURL, ...props }) => {
    const apiRef = useGridApiRef();
    const locale = useSelector(state => state.i18n.locale);

    const [entitiesLastTwelveMonths, setEntitiesLastTwelveMonths] = useState([]);
    const [selectedUserRole, setSelectedUserRole] = useState(t("diagram.AllUsers"));

    const languages = {
        'ENG': 'en-US',
        'FRA': 'fr-FR',
        'SPA': 'es-ES',
        'POR': 'pt-PT',
        'NLD': 'nl-NL',
        'DEU': 'de-DE'
    };

    /* eslint-disable */

    const getLastTwelveMonths = () => {
        const months = [];
        const currentDate = new Date();
        
        for(let i = 0; i < 12; i++) {
            const month = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            const year = month.getFullYear().toString().slice(-2);
            const monthName = month.toLocaleString(languages[locale], { month: 'short' });
                months.push({
                    field: `Month${i+1}`,
                    headerName: `${monthName}-${year}`,
                    flex: 1,
                    editable: true,
                    minWidth: 70
                });
        }

        return months;
    };

    useEffect(() => {
        setEntitiesLastTwelveMonths(getLastTwelveMonths(true));
    }, []);

    /* eslint-disable */

    const editingRights = useEditionRightsPerUserStatus([
        "EntityManager",
        "Contributor",
    ]);

    const entityGridSpecificColumns = [
        {
            field: "EntityName",
            headerName: t("field.Entity"),
            flex: 1,
            editable: true,
            minWidth: 210
        },
        {
            field: "Active",
            headerName: t("common.Active"),
            flex: 1,
            editable: true,
            minWidth: 75
        },
        {
            field: "Inactive",
            headerName: t("common.Inactive"),
            flex: 1,
            editable: true,
            minWidth: 75
        }
    ]
    .concat(entitiesLastTwelveMonths);


    return (
        <>
            <DataGridComponent
                apiRef={apiRef}
                baseURL={"user/GetActiveUsersByEntity"}
                label={label}
                gridSpecificColumns={entityGridSpecificColumns}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "EntityName", sort: "asc" }],
                    },
                    pinnedColumns: {
                        left: [`EntityName`]
                    }
                }}
                editingRights={editingRights}
                getDetailPanelHeight={() => "auto"}
                isAddDisabled={true}
                hideActionColumn={true}
                toolbar={{
                    newFilter: (
                        <FilterToolbar
                            options={userRole.map(e => ({
                                ...e,
                                label: t(`diagram.${e.label}`)
                            }))}
                            disableClearable
                            placeholder={t("diagram.AllUsers")}
                            value={selectedUserRole}
                            onChange={(e, value) =>
                                value
                                    ? setSelectedUserRole(t(`diagram.${value.value}`))
                                    : setSelectedUserRole("")
                            }
                        />
                    ),
                }}
                paramURL={
                    selectedUserRole
                        ? `filter[Role]=${selectedUserRole}`
                        : r.filter.allFilter
                }
                {...props}
            />
        </>
    );
};

export default UsersStatsByEntityGrid;
